<template>
    <lyTable @tr="rowData" height="200" :columns="columns" :data="tableData">

    </lyTable>
</template>
<script>
export default {
    props: ['tableData'],
    data() {
        return {
            columns: [
                {
                    type: "index",
                    width: 70,
                    align: "center",
                },
                {
                    title: "车牌号",
                    key: "carNo",
                },
                {
                    title: "gps时间",
                    key: "gpsTime1",
                },
                {
                    title: "速度",
                    key: "speed",
                },
                {
                    title: "发动机",
                    key: "accStatus1",
                },
                {
                    title: "里程",
                    key: "mileage",
                },
                {
                    title: "事件报告",
                    key: "eventDesc",
                },
            ],
            //tableData: [],

        };
    },
    methods: {
        rowData(row) {
            console.log(row);
            this.$emit('row', row)
        }
    },
    mounted() {

    },
};
</script>


// WEBPACK FOOTER //
// src/components/tangci/tlist.vue